import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { startWith } from "rxjs/operators";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { Order } from "src/app/core/entities/order";
import { OrderItem } from "src/app/core/entities/orderItem";
import { ObserverPedido, PedidoService } from "src/app/core/services/pedido-service";
import { ProductService } from "src/app/core/services/product-service";
@Component({
  selector: "app-catalog-cart",
  templateUrl: "./catalog-cart.component.html",
  styleUrls: ["./catalog-cart.component.css"],
})
export class CatalogCartComponent implements OnInit, OnDestroy, ObserverPedido {
  @Output() showCart = new EventEmitter<void>();
  @Output() hideCart = new EventEmitter<void>();
  @Output() itemEmitted = new EventEmitter<OrderItem>();
  @Output() minimizedChange = new EventEmitter<boolean>();
  titleBackgroundColor: string;
  minimized = false;
  items: OrderItem[] = [];
  orderItems: OrderItem[] = [];
  imageApi: string;
  imageApiProdutos: string;
  total = 0;
  SITE;

  constructor(private pedidoService: PedidoService, private router: Router,private productService: ProductService,) {
    this.titleBackgroundColor =
      Configuracoes.SITE.backgroundColorSliderSuperior;
  }

  notify(pedido: Order) {
    this.orderItems = pedido.itens;
    this.refresh();
  }

  ngOnInit() {
    this.SITE = Configuracoes.SITE;
    this.imageApi = Configuracoes.API_IMAGENS;
    this.imageApiProdutos = Configuracoes.API_IMAGENS_PRODUTOS;
    this.orderItems = this.pedidoService.pedido.itens;
    this.refresh();
    this.pedidoService.registerObserver(this);
  }

  ngOnDestroy(): void {
    this.pedidoService.removeObserver(this);
  }

  removeItem(item: OrderItem) {
    // emite o item para o componente pai
    
    this.pedidoService.removeCartItem(
      item.produto,
      (order: Order) => {
        this.pedidoService.select(order);
        this.pedidoService.removed();
        this.itemEmitted.emit(item);
        this.productService.setItemRemoved(item.produto)
        if (!this.items.length) this.hideCart.emit();
      },
      item.pedidocliente_id
    );
  }
  

  refresh() {
  this.items = [];

  const productsMap = new Map<string, any>();

  this.orderItems
    .sort((a, b) => b.id - a.id)
    .forEach((item) => {
      const key = item.produtoReferencia;

      if (!productsMap.has(key)) {
        productsMap.set(key, { ...item });
      } else {
        const aggregatedItem = productsMap.get(key);

        aggregatedItem.quantidade += item.quantidade;
        aggregatedItem.total += item.total;
        aggregatedItem.subtotal += item.subtotal;
      }
    });

  this.items = Array.from(productsMap.values()).filter(
    item => item.quantidade > 0
  );

  this.total = this.items.reduce(
    (total, item) => total + item.subtotal,
    0
  );
}

  redirectTo(url: string) {
    this.hideCart.emit();
    this.router.navigate([url]);
  }

  get itemCount(): number {
    return this.items.reduce((sum, item) => sum + (Number(item.quantidade) || 0), 0);
  }

  toggleMinimize(event: Event) {
    event.stopPropagation();
    this.minimized = !this.minimized;
    this.minimizedChange.emit(this.minimized);
  }

}
